import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ProgressNavShared {
  constructor() {}

  private progressNavNextStepObs = new BehaviorSubject<boolean>(false);
  progressNavNextStepObs$ = this.progressNavNextStepObs.asObservable();

  private progressNavPreStepObs = new BehaviorSubject<boolean>(false);
  progressNavPreStepObs$ = this.progressNavPreStepObs.asObservable();

  private progressNavShowBackButtonObs = new BehaviorSubject<boolean>(false);
  progressNavShowBackButtonObs$ =
    this.progressNavShowBackButtonObs.asObservable();

  private progressNavHideBackButtonObs = new BehaviorSubject<boolean>(false);
  progressNavHideBackButtonObs$ =
    this.progressNavHideBackButtonObs.asObservable();

  progressNavNextStep() {
    this.progressNavNextStepObs.next(true);
    this.progressNavNextStepObs.next(false);
  }

  progressNavPreStep() {
    this.progressNavPreStepObs.next(true);
    this.progressNavPreStepObs.next(false);
  }

  progressNavShowBackButton() {
    this.progressNavShowBackButtonObs.next(true);
    this.progressNavShowBackButtonObs.next(false);
  }

  progressNavHideBackButton() {
    this.progressNavHideBackButtonObs.next(true);
    this.progressNavHideBackButtonObs.next(false);
  }
}
